import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PeepingLogo } from "@/components/PeepingLogo";
import { BG_IMAGE } from "@/lib/demoImages";
import { useAuth } from "@/context/AuthContext";
import { homeFor } from "@/lib/api";

export default function Splash() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user === null) return undefined;
    const t = setTimeout(() => navigate(user ? homeFor(user) : "/welcome", { replace: true }), user ? 900 : 2600);
    return () => clearTimeout(t);
  }, [navigate, user]);

  return (
    <div
      data-testid="splash-screen"
      className="relative min-h-screen overflow-hidden bg-[#080808] grain flex flex-col items-center justify-center"
    >
      <img
        src={BG_IMAGE}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover object-top opacity-55 scale-110 blur-[2px]"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#080808]/40 via-[#080808]/70 to-[#080808]" />
      <div className="absolute -top-20 right-0 h-72 w-72 glow-magenta opacity-60" />
      <div className="absolute bottom-10 -left-16 h-64 w-64 glow-violet opacity-50" />

      <div className="relative z-10 flex flex-col items-center animate-fade-up">
        <PeepingLogo className="w-56 sm:w-64" />
      </div>

      <div className="relative z-10 mt-16 flex flex-col items-center gap-4">
        <div className="h-[3px] w-40 overflow-hidden rounded-full bg-white/10">
          <div
            className="h-full w-full bg-gradient-to-r from-[#6a00ff] to-[#d42be8]"
            style={{ animation: "loadBar 2.4s ease-out forwards" }}
          />
        </div>
        <p className="text-[0.6rem] uppercase tracking-[0.35em] text-[#a7a0af]">
          Preparing your experience
        </p>
      </div>
    </div>
  );
}
